import * as React from 'react';
import ReactDOM from 'react-dom';
import { MaterialSpinner } from './material-spinner';

interface ISpinnerProps {
    radius: number;
    color: string;
    stroke: number;
    visible: boolean;
}

const DefaultSpinnerPresentation = (props: ISpinnerProps) => {
    return (<>
        {props.visible && <div className='overlay-background'>
                <MaterialSpinner {...props} />
            </div>
        }
        </>
    );
};

const DefaultSpinner = (props: Partial<ISpinnerProps>) => {
    const defaults = {
        radius: props.radius ?? 120,
        color: props.color ?? '#1a1a1a',
        stroke: props.stroke ?? 4,
        visible: props.visible ?? false
    };
    return ReactDOM.createPortal(<DefaultSpinnerPresentation {...defaults}/>, document.getElementById('oe-connect-root'));
};

export { DefaultSpinner, DefaultSpinnerPresentation };
